export const getRecaptchaToken = () => {
    return new Promise((resolve, reject) => {
        const script = document.getElementById('recaptcha');
        const siteKey = script ? script.getAttribute('data-site-key') : null;
        if (siteKey && window.grecaptcha) {
            window.grecaptcha.ready(
                function () {
                    window.grecaptcha
                        .execute(siteKey, { action: 'submit' })
                        .then(function (token) {
                            resolve(token);
                        })
                        .catch(reject);
                },
                function (err) {
                    reject(err);
                }
            );
        } else {
            console.warn('Recaptcha not configured.');
            resolve(null);
        }
    });
};

export const loadRecaptcha = () => {
    const loadScript = () => {
        if (document.getElementById('recaptcha-container')?.childElementCount === 0) {
            const INTERVAL_MILLISECONDS = 200;
            const FOCUS_ATTRIBUTE = 'data-focus-listener';
            const CLICK_ATTRIBUTE = 'data-click-listener';

            let loadRecaptchaScript = function () {
                if (!document.getElementById('recaptcha')) {
                    let script = document.createElement('script');
                    script.setAttribute('id', 'recaptcha');
                    script.setAttribute('data-site-key', window.recaptchaSiteKey);
                    script.setAttribute(
                        'src',
                        `https://www.google.com/recaptcha/api.js?render=${window.recaptchaSiteKey}`
                    );
                    document.getElementById('recaptcha-container').appendChild(script);
                }
            };

            let timeout = setTimeout(function () {
                loadRecaptchaScript();
            }, 10000);

            let milliseconds = 200;
            let interval = setInterval(function () {
                let formElements = document.querySelectorAll('form input, form select');
                let submitElements = document.querySelectorAll("button[type='submit']");

                if (formElements && formElements.length > 0) {
                    formElements.forEach(function (element) {
                        if (!element.getAttribute(FOCUS_ATTRIBUTE)) {
                            element.setAttribute(FOCUS_ATTRIBUTE, 'true');
                            element.addEventListener(
                                'focus',
                                function () {
                                    clearTimeout(timeout);
                                    loadRecaptchaScript();
                                },
                                { once: true }
                            );
                        }
                    });
                }

                if (submitElements && submitElements.length > 0) {
                    submitElements.forEach(function (element) {
                        if (!element.getAttribute(CLICK_ATTRIBUTE)) {
                            element.setAttribute(CLICK_ATTRIBUTE, 'true');
                            element.addEventListener(
                                'click',
                                function () {
                                    clearTimeout(timeout);
                                    loadRecaptchaScript();
                                },
                                { once: true }
                            );
                        }
                    });
                }

                if (milliseconds >= 10000) {
                    clearInterval(interval);
                }
                milliseconds += INTERVAL_MILLISECONDS;
            }, 200);
        }
    };
    if (document.readyState !== 'loading') {
        loadScript();
    } else {
        document.addEventListener('DOMContentLoaded', loadScript);
    }
};
